import { createSelector } from 'reselect';
import { RootState } from '../../model/rootReducer';

const selectIntents = (state: RootState) => state.intent.intents;

export const selectIntentsMinimized = createSelector(
  selectIntents,
  (selectIntents) => selectIntents.map(({ id, title }) => ({ id, title })),
);

export const selectIntentById = createSelector(
  selectIntents, (state: RootState, id: number | undefined) => id,
  (selectIntents, id: number | undefined) => selectIntents.find((x) => x.id === id),
);
